import React from "react";
import { useTranslation } from "react-i18next";
import StatusModal, { STATUS } from "../../../../../../components/modal/StatusModal";

// Shown after the "change password" email has been sent.
const ModalSuccessChangePassword = ({
  handleClose,
  show,
}) => {
  const { t } = useTranslation();

  return (
    <StatusModal
      show={show}
      onClose={handleClose}
      status={STATUS.SUCCESS}
      titleHtml={t("myPage.accountInformation.modalSuccessChangePassword.desc")}
    />
  );
};

export default ModalSuccessChangePassword;
